// extracted by mini-css-extract-plugin
export default {"popupHeader":"PopupHeader_popupHeader__MG6md","title":"PopupHeader_title__0AsKA","iconContainer":"PopupHeader_iconContainer__Jx1HK","exitIcon":"PopupHeader_exitIcon__JbqQo"};